export const LOG_IN = 'LOG_IN';
export const UDPATE_FORM = 'UDPATE_FORM';
export const SET_FORM = 'SET_FORM';
export const UPDATE_CALENDAR = 'UPDATE_CALENDAR'
export const SET_TABLE = 'SET_TABLE'
export const UPDATE_TABLE = 'UPDATE_TABLE'
export const SET_REFRESH_TREATMENT_TABLE = 'SET_REFRESH_TREATMENT_TABLE'